// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3GnBz","emails":"CreateEditClinics_emails__2db7F","emailTagLabel":"CreateEditClinics_emailTagLabel__2dGxB"};